var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHighlights4 = function SvgHighlights4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "highlights4_svg__Group_1122",
    x: 0,
    y: 0,
    viewBox: "0 0 49.6 45.4",
    role: "img"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".highlights4_svg__st1{fill:#616e7d}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "highlights4_svg__Path_8493",
    d: "M24.8 9C21.9 2.4 14.2-.5 7.7 2.4S-1.8 13 1.1 19.5c.2.5.5 1.1.8 1.5h14.8l4.8-10.7 5.3 17.9 3.6-7.2h17.2q.75-1.05 1.2-2.4C51.2 12 47.7 4.5 41 2.1 34.6-.1 27.6 2.8 24.8 9",
    className: "highlights4_svg__st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "highlights4_svg__Path_8494",
    d: "m31.6 23-5.3 10.5-5.2-17.6L18 23H3.3l1.2 1.2 19.8 19.7c.1.1.3.2.4.2.2 0 .3-.1.4-.2l20.5-20.4c.1-.2.3-.3.4-.5z",
    className: "highlights4_svg__st1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "highlights4_svg__Path_8495",
    d: "m26.8 28.3-5.3-17.9-4.8 10.7H1.9c.4.6.8 1.2 1.2 1.7l.2.2H18l3.2-7.1 5.2 17.6L31.6 23h14.7c.5-.6 1-1.2 1.4-1.9H30.4z",
    style: {
      fill: "#aad4c8"
    }
  }));
};
export default SvgHighlights4;